import { createMachine } from "xstate";

export type MapPanelEvent =
  | { type: "MODE_POINT" }
  | { type: "MODE_SEARCH" }
  | { type: "CLOSING" }
  | { type: "OPENING_POINT" }
  | { type: "CLOSING_POINT" }
  | { type: "CLOSING_SEARCH" }
  | { type: "OPENING_SEARCH" };

export type MapPanelState = MapPanelStatePoint | "closed" | MapPanelStateSearch;
export type MapPanelStatePoint = { point: "pointCollapsed" | "pointOpen" };
export type MapPanelStateSearch = { search: "searchCollapsed" | "searchOpen" };

export const mapPanelMachine = createMachine<
  unknown,
  MapPanelEvent,
  { value: MapPanelState; context: unknown }
>({
  id: "panelState",
  initial: "closed",
  states: {
    closed: {
      on: {
        MODE_POINT: { target: "point" },
        MODE_SEARCH: { target: "search" },
      },
    },
    point: {
      on: {
        CLOSING: { target: "closed" },
        MODE_SEARCH: { target: "search" },
      },
      initial: "pointOpen",
      states: {
        pointOpen: { on: { CLOSING_POINT: { target: "pointCollapsed" } } },
        pointCollapsed: {
          on: {
            OPENING_POINT: { target: "pointOpen" },
          },
        },
      },
    },
    search: {
      on: {
        CLOSING: { target: "closed" },
        MODE_POINT: { target: "point" },
      },
      initial: "searchOpen",
      states: {
        searchOpen: {
          on: { CLOSING_SEARCH: { target: "searchCollapsed" } },
        },
        searchCollapsed: {
          on: {
            OPENING_SEARCH: { target: "searchOpen" },
          },
        },
      },
    },
  },
});
